<template>
  <div class="info-container">
    <div class="content">
      <div v-if="itemList.length > 0 || scrollFlag">
        <Item 
          v-for="(v, i) in itemList"
          :key="i"
          :every="v"
          :curcer="v.articleId"
          @itemClick="goDetail(v)">
        </Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
      </div>
      <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import Item from "@/components/pager/Item";
import mixin from "@/mixins/esIndex";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    Item,
    Scroll,
    NoData,
  },
  mixins: [mixin],
  data() {
    return {
      itemList: [],
      params: {
        pageNo: 1,
        types: "0,3",
        // articleTypes: null,
        // searchType:this.$route.query.searchType,
        paramStr: this.$route.query.paramStr,
        searchType:this.$route.query.searchType
      },
    };
  },
  created() {
    // 论文列表
    this.getSearchList(this.params);
  },
  methods: {
    jumpType(type) {
      switch (type)
      {
        case 0:
          type = '/thesisDetail'
          break;
        case 1:
          type = '专利' // 暂无此项
          break;
        case 2:
          type = '/concentrationDetails'
          break;
        case 3:
          type = '科技报告' // 暂无此项
          break;
        case 4:
          type = '标准' // 暂无此项
          break;
        case 5:
          type = '/msgDetails'
          break;
        case 6:
          type = '/dataDetails'
          break;
        case 8:
          type = '/meetingDetails'
          break;
        case 9:
          type = '/courseDetails'
          break;
      }
      return type
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: this.jumpType(e.articleType),
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
